export default __webpack_public_path__ + "static/media/eye.08ec216e.svg";